import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type TitleJSON = z.infer<typeof TitleSchema.TitleJSONZ>;
export type TitleParams = z.infer<typeof TitleSchema.TitleZ>;

export default class TitleSchema {
  public static readonly TitleJSONZ = z.string().min(1, { message: "Entity title cannot be empty" });
  public static readonly TitleZ = z.string().min(1, { message: "Entity title cannot be empty" });

  public static validate(values: unknown): TitleParams {
    return parseOrThrow(TitleSchema.TitleZ, values, {
      logError: true,
      schemaName: "TitleSchema",
      operation: "validate",
      payloadSample: values,
    });
  }

  public static validateJSON(values: unknown): TitleJSON {
    return parseOrThrow(TitleSchema.TitleJSONZ, values, {
      logError: true,
      schemaName: "TitleSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValid(values: unknown): values is TitleParams {
    try {
      TitleSchema.validate(values);
      return true;
    } catch {
      return false;
    }
  }

  public static isValidJSON(values: unknown): values is TitleJSON {
    try {
      TitleSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): TitleParams {
    const validatedJSON = TitleSchema.validateJSON(data);
    return TitleSchema.validate(validatedJSON);
  }

  public static serialize(data: TitleParams): TitleJSON {
    return TitleSchema.validate(data);
  }
}
